<template>
   <div>
     <NuxtPage />
     <PickerBackdrop />
  </div>
</template>

<style>
.page-enter-active,
.page-leave-active {
  transition: all 0.1s;
}
.page-enter-from,
.page-leave-to {
  opacity: 0;
  position: absolute;
  filter: blur(1rem);
}
</style>